import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7507dc33"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container text-center" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "container team_listings mt-5" };
const _hoisted_6 = { class: "team_listings--single" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "team_listings--single__job-title" };
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'team_listing',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function getTextColour(defaultColour) {
            if (props.d.background_colour === '#FF5317') {
                return '#fff';
            }
            return defaultColour;
        }
        return (_ctx, _cache) => {
            const _component_arrow = _resolveComponent("arrow");
            const _component_arrow_link = _resolveComponent("arrow-link");
            return (_openBlock(), _createElementBlock("div", {
                class: "team_listing",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h2", {
                        class: "mb-4 d-flex flex-column",
                        style: _normalizeStyle({ color: getTextColour('#000') })
                    }, [
                        (__props.d.line_one)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                innerHTML: __props.d.line_one
                            }, null, 8, _hoisted_2))
                            : _createCommentVNode("", true),
                        (__props.d.line_two)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                innerHTML: __props.d.line_two,
                                class: "text-primary"
                            }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true)
                    ], 4),
                    (__props.d.leadin)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "team_listing--leadin",
                            innerHTML: __props.d.leadin,
                            style: _normalizeStyle({ color: getTextColour('#000') })
                        }, null, 12, _hoisted_4))
                        : _createCommentVNode("", true),
                    _createVNode(_component_arrow, {
                        isWhite: __props.d.background_colour === '#FF5317'
                    }, null, 8, ["isWhite"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.team, (member) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["img-wrapper mb-2", { 'image-wrapper__hover': member.alias }])
                            }, [
                                _createElementVNode("img", {
                                    src: member.image,
                                    class: "img-fluid",
                                    alt: member.title,
                                    loading: "lazy"
                                }, null, 8, _hoisted_7),
                                _createElementVNode("a", {
                                    href: member.alias,
                                    class: "overlay no-style"
                                }, "View Profile", 8, _hoisted_8)
                            ], 2),
                            _createElementVNode("p", {
                                class: "team_listings--single__title",
                                style: _normalizeStyle({ color: getTextColour('#FF5317') })
                            }, _toDisplayString(member.title), 5),
                            _createElementVNode("p", _hoisted_9, _toDisplayString(member.job_title), 1),
                            (member.short_leadin)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "team_listings--single__leadin",
                                    innerHTML: member.short_leadin,
                                    style: _normalizeStyle({ color: getTextColour('#000ß') })
                                }, null, 12, _hoisted_10))
                                : _createCommentVNode("", true),
                            (member.alias)
                                ? (_openBlock(), _createBlock(_component_arrow_link, {
                                    key: 1,
                                    hasAnimation: false,
                                    link: member.alias,
                                    text: "View Profile"
                                }, null, 8, ["link"]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 256))
                ]),
                (__props.d.footer_text)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "footer-text",
                        innerHTML: __props.d.footer_text
                    }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true)
            ], 4));
        };
    }
});
